import { ComponentProps } from 'react';
import { clsx } from 'clsx';

export interface LetUsHelpBaseFormProps extends ComponentProps<'form'> {}
export const LetUsHelpBaseForm = ({
  className,
  children,
  ...props
}: LetUsHelpBaseFormProps) => {
  return (
    <form
      className={clsx(
        className,
        'flex flex-col rounded bg-background-base-surface-2 p-6 shadow',
      )}
      {...props}
    >
      {children}
    </form>
  );
};
